<div [ngClass]="{ inline: isInline }" class="fullModal opened addForm" id="AddServiceModal">
  <app-loader [isLoading]="isLoading"></app-loader>

  <div [hidden]="step !== 0" class="fullRow" id="ServiceUpload">
    <div [ngClass]="{ isAt: step === 0 }" class="stepItem">
      <div class="title" style="filter: brightness(50%)">Import your Service As Code</div>
      <div class="subtitle">Select Your File To Upload</div>
      <div class="sized">
        <!-- Service BULK Add -->
        <div class="subtext row">
          Creating Services using only code is easy. Just download our template below, update the code, and
          upload your file. We’ll create the Services and provide you with a summary and list of next steps.
        </div>
        <div class="label row">Download A Template</div>
        <div (click)="download()" class="graphicButtonCSV">
          <div>Download An<br />Example File</div>
          <div class="iconCSV"></div>
        </div>

        <div class="label row">Select And Upload A File</div>
        <div (onFileDrop)="fileDrop()" [uploader]="uploader" class="uploadArea" ng2FileDrop>
          <div [hidden]="fileIsReady" class="label">Drag and drop a CSV file</div>
          <div [hidden]="fileIsReady" class="sublabel">
            or
            <div (click)="showDialog()" class="linkButton" id="ServiceFileUpload">
              Select a file from your computer
            </div>
            <form [formGroup]="form">
              <input
                #fileInput
                (change)="onFileChange($event)"
                id="FileSelect"
                name="file"
                style="display: none"
                type="file"
                />
            </form>
          </div>
          <div [hidden]="!fileIsReady" class="label">Click create to import CSV</div>
        </div>
        <div class="row buttonRow right" style="margin-top: 1.25rem">
          @if (!processing) {
            <button (click)="save()" class="save" id="saveServiceButton">Create</button>
          }
          @if (processing) {
            <button class="save confirm" disabled>
              Saving <span class="spinner"></span>
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="step !== 1" class="fullRow" id="ServiceBuildingStatus">
    <div [ngClass]="{ isAt: step === 1 }" class="sized nextStep">
      <app-services-bulk-upload-save
        #saveServicesAsCode
        [businessKey]="businessKey"
        [networkId]="networkId"
        [services]="services"
        >
      </app-services-bulk-upload-save>
    </div>
  </div>

  <div (click)="close()" class="buttonBall close" id="CloseServiceUploadButton">
    <div class="buttonLabel">ESC</div>
  </div>
  @if (!hideHelp) {
    <app-form-support-button></app-form-support-button>
  }
</div>
